//import react section
import React, { useState } from 'react'
import PropTypes from 'prop-types'
//import material ui section
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
// import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
//import resources section
import inconWarrantyActive from '../../../../resources/images/warrantyActive.svg'
import inconWarrantyDesactive from '../../../../resources/images/warrantyDesactive.svg'
import inconWarrantyPartial from '../../../../resources/images/warrantyPartial.svg'
import SerieDetail from './PaymentDetailsComponent'

const SeriesTable = (props) => {
	const { onWarrantyIconClick, service, onDeleteSerieFromService } = props

	const [expandedRows, setExpandedRows] = useState({})

	const getWarrantyIcon = (warrantyStatus) => {
		if (warrantyStatus === 'UnderWarranty') return inconWarrantyActive
		if (warrantyStatus === 'OutWarranty') return inconWarrantyDesactive
		return inconWarrantyPartial
	}

	const getWarrantyTooltip = (warrantyStatus) => {
		if (warrantyStatus === 'UnderWarranty') return 'Under Warranty'
		if (warrantyStatus === 'OutWarranty') return 'Out of Warranty'
		return 'Expiration Warranty'
	}

	const toggleRowExpansion = (token) => {
		setExpandedRows((prev) => ({
			...prev,
			[token]: !prev[token]
		}))
	}

	return (
		<Paper
			style={{
				padding: '12px'
				// height: '100%',
				// display: 'flex',
				// flexDirection: 'column',
				// overflow: 'hidden',
				// boxSizing: 'border-box'
			}}
		>
			<Typography variant='h6' style={{ marginBottom: '8px', flexShrink: 0, fontSize: '1rem' }}>
				Series ({service?.Equipments?.length})
			</Typography>
			<TableContainer>
				<Table stickyHeader size='small'>
					<TableHead>
						<TableRow>
							<TableCell style={{ width: '50px' }}></TableCell>
							<TableCell>
								<strong>Serial</strong>
							</TableCell>
							<TableCell align='center'>
								<strong>Warranty</strong>
							</TableCell>
							<TableCell>
								<strong>Model</strong>
							</TableCell>
							<TableCell align='center'>
								<strong>Actions</strong>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{service?.Equipments.map((equipmentItem) => {
							console.log('equipmentItem in SeriesTable=', equipmentItem)
							return (
								<React.Fragment key={equipmentItem.Token}>
									<TableRow>
										<TableCell>
											<IconButton
												size='small'
												onClick={() => toggleRowExpansion(equipmentItem.Token)}
												style={{ padding: '4px' }}
											>
												{expandedRows[equipmentItem.Token] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
											</IconButton>
										</TableCell>
										<TableCell>{equipmentItem.Serie}</TableCell>
										<TableCell align='center'>
											<Tooltip title={getWarrantyTooltip(equipmentItem.WarrantyStatus)}>
												<IconButton
													size='small'
													onClick={() => onWarrantyIconClick(equipmentItem)}
													style={{ padding: '2px' }}
												>
													<img
														src={getWarrantyIcon(equipmentItem.WarrantyStatus)}
														alt='warranty-icon'
														style={{ width: '28px', height: '28px', cursor: 'pointer' }}
													/>
												</IconButton>
											</Tooltip>
										</TableCell>
										<TableCell>{equipmentItem.Model}</TableCell>
										<TableCell align='center'>
											{/* <Tooltip title='Next'>
											<IconButton
												size='small'
												onClick={() => onNextStep(equipmentItem)}
												style={{ padding: '4px', color: '#1976d2' }}
											>
												<ArrowForwardIcon fontSize='small' />
											</IconButton>
										</Tooltip> */}
											<Tooltip title='Eliminar serie'>
												<IconButton
													size='small'
													onClick={() => onDeleteSerieFromService(equipmentItem.Token)}
													style={{ padding: '4px', color: '#f44336' }}
												>
													<DeleteIcon fontSize='small' />
												</IconButton>
											</Tooltip>
										</TableCell>
									</TableRow>
									<TableRow style={{ paddingBottom: 0, paddingTop: 0 }}>
										<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
											<SerieDetail
												equipmentItem={equipmentItem}
												isOpen={expandedRows[equipmentItem.Token] || false}
												service={service}
											/>
										</TableCell>
									</TableRow>
								</React.Fragment>
							)
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	)
}

SeriesTable.propTypes = {
	addedSeries: PropTypes.arrayOf(
		PropTypes.shape({
			Token: PropTypes.string.isRequired,
			Serie: PropTypes.string.isRequired,
			WarrantyStatus: PropTypes.string.isRequired,
			Model: PropTypes.string.isRequired
		})
	).isRequired,
	onWarrantyIconClick: PropTypes.func.isRequired,
	onDeleteSerie: PropTypes.func.isRequired,
	onNextStep: PropTypes.func.isRequired,
	serviceData: PropTypes.object
}

export default SeriesTable
